import { Action } from '../core/action'

// Copied from react-admin/ra-core to avoid dependency issues
type Identifier = string | number

interface Record {
  id: Identifier
  [key: string]: any
}

interface Pagination {
  page: number
  perPage: number
}

interface Sort {
  field: string
  order: string
}

type ValidUntil = Date

export interface GetListParams {
  pagination: Pagination
  sort: Sort
  filter: any
}

export interface GetListResult {
  data: Record[]
  total: number
  validUntil?: ValidUntil
}

export interface GetOneParams {
  id: Identifier
}

export interface GetOneResult {
  data: Record
  validUntil?: ValidUntil
}

export interface GetManyParams {
  ids: Identifier[]
}

export interface GetManyResult {
  data: Record[]
  validUntil?: ValidUntil
}

export interface GetManyReferenceParams {
  target: string
  id: Identifier
  pagination: Pagination
  sort: Sort
  filter: any
}

export interface GetManyReferenceResult {
  data: Record[]
  total: number
  validUntil?: ValidUntil
}

export interface UpdateParams {
  id: Identifier
  data: any
  previousData: Record
}

export interface UpdateResult {
  data: Record
  validUntil?: ValidUntil
}

export interface UpdateManyParams {
  ids: Identifier[]
  data: any
}

export interface UpdateManyResult {
  data?: Identifier[]
  validUntil?: ValidUntil
}

export interface CreateParams {
  data: any
}

export interface CreateResult {
  data: Record
  validUntil?: ValidUntil
}

export interface DeleteParams {
  id: Identifier
}

export interface DeleteResult {
  data?: Record
}

export interface DeleteManyParams {
  ids: Identifier[]
}

export interface DeleteManyResult {
  data?: Identifier[]
}

export const dataProvider = {
  // Actions
  getList: new Action<[resource: string, params: GetListParams], GetListResult>(),
  getOne: new Action<[resource: string, params: GetOneParams], GetOneResult>(),
  getMany: new Action<[resource: string, params: GetManyParams], GetManyResult>(),
  getManyReference: new Action<[resource: string, params: GetManyReferenceParams], GetManyReferenceResult>(),
  update: new Action<[resource: string, params: UpdateParams], UpdateResult>(),
  updateMany: new Action<[resource: string, params: UpdateManyParams], UpdateManyResult>(),
  create: new Action<[resource: string, params: CreateParams], CreateResult>(),
  delete: new Action<[resource: string, params: DeleteParams], DeleteResult>(),
  deleteMany: new Action<[resource: string, params: DeleteManyParams], DeleteManyResult>(),
} as const
